export function getDeliveryZoneNames(reseller, deliveryZoneId) {
    if (!deliveryZoneId?.length) return []

    const ids = Array.isArray(deliveryZoneId) ? deliveryZoneId : [deliveryZoneId]

    return ids
        .map((id) => reseller?.settings?.deliveryZones?.find((zone) => zone.id === id)?.name)
        .filter((name) => !!name)
}
